import { Validators } from "@angular/forms";
import { LayerType, overlayBlur, sharedForms } from "../layer.model";
import { FormType, MaterialOverlayProperties, Properties } from "../properties.model";

export const materialOverlayForm: Properties = {
  propertyType: LayerType.MaterialOverlay,
  label: 'Building Layer',
  forms:
    sharedForms.concat([
    {
      id: MaterialOverlayProperties.MaterialOverlaySelector,
      label: 'Material',
      type: FormType.Multiselect,
      placeholder: 'Materials',
      defaultValue: [],
      validators: [],
      options: []
    },
    {
      id: MaterialOverlayProperties.MaterialOverlayColor,
      label: 'Fill Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: MaterialOverlayProperties.MaterialOverlayOpacity,
      label: 'Fill Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      hint: "Modify the opacity of the fill. Useful for hiding the fill color while preserving opacity of effects like outline.",
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    overlayBlur
  ]),
  changeHandler: () => {},
  onInit: (data ) => {
    const selector = materialOverlayForm.forms.find(form => form.id === MaterialOverlayProperties.MaterialOverlaySelector)
    if (selector) {
      selector.options = data.stringEncodings.materials.map((material, idx) => ({label: material, value: idx+1}))
      selector.options.sort((a,b) => a.label.localeCompare(b.label))
      const grassOption = selector.options.find(option => option.label === 'Grass')
      if (grassOption) {
        selector.defaultValue = [grassOption]
      }
    }
  }
}
